import React from 'react';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { ROUTE_GROUPS_SUPPORT_CENTER_SETTINGS } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import { NORMAL_EARLY_ASSET_STRATEGY } from '@atlassian/jira-common-constants/src/ssr-early-assets.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { agentStudioRoute } from '@atlassian/jira-router-routes-agent-studio-routes/src/index.tsx';

export const agentStudioRouteEntry = createEntry(agentStudioRoute, () => ({
	group: ROUTE_GROUPS_SUPPORT_CENTER_SETTINGS,
	component: () => <div>Agent studio soon tm</div>,
	layout: globalLayout,
	resources: [...getNavigationResources()],
	forPaint: [LazyAtlassianNavigation],
	earlyAssets: NORMAL_EARLY_ASSET_STRATEGY,
}));
